__turbopack_context__.v({
  "body": "Body-module-scss-module__jY8FQW__body",
  "centered": "Body-module-scss-module__jY8FQW__centered",
});
